export function nextWidgetMode(current, action) {
  const map = { launch: 'open', expand: 'expanded', minimize: 'open', hide: 'hidden' }
  return map[action] || current
}
